module.exports = "img/flags/KG.6f69b51.png";